import { transformImage } from '@/resources/storyblok/helpers';

export default function ({ banners }) {
  return (
    banners?.map(({ title, link, imgMobile, imgDesktop, enabledFor, trackingId, id }) => ({
      title,
      link,
      imgMobile: {
        src: transformImage(imgMobile.filename, 'filters:format(webp)'),
        height: imgMobile.filename?.split('/')[5].split('x')[1]
      },
      imgDesktop: {
        src: transformImage(imgDesktop.filename, 'filters:format(webp)'),
        height: imgDesktop.filename?.split('/')[5].split('x')[1]
      },
      enabledFor,
      trackingId,
      id
    })) || []
  );
}
